/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Settings_EmptyInputs */

const en_task_settings_empty = /** @type {(inputs: Task_Settings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No activities found.`)
};

const pt_br2_task_settings_empty = /** @type {(inputs: Task_Settings_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma atividade encontrada.`)
};

/**
* | output |
* | --- |
* | "No activities found." |
*
* @param {Task_Settings_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_empty = /** @type {((inputs?: Task_Settings_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_empty(inputs)
	return pt_br2_task_settings_empty(inputs)
});